import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllSettingsAction,
  GetAppSettingsAction,
  UpdateSettingsAction,
} from "store/middlewares/settings/settings";

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    settingsLoading: false,
    settings: null,
  },
  extraReducers(builder) {
    builder
      // Get All Settings
      .addCase(GetAllSettingsAction.pending, (state) => {
        state.settingsLoading = true;
        state.settings = null;
      })
      .addCase(GetAllSettingsAction.fulfilled, (state, action) => {
        state.settingsLoading = false;
        state.settings = action.payload.response;
      })
      .addCase(GetAllSettingsAction.rejected, (state) => {
        state.settingsLoading = false;
        state.settings = null;
      })
      // Update Settings
      .addCase(UpdateSettingsAction.fulfilled, (state, action) => {
        state.settingsLoading = false;
        state.settings = { ...state.settings, ...action.payload.response };
      })

      .addCase(GetAppSettingsAction.pending, (state) => {
        state.settingsLoading = true;
        state.settings = null;
      })
      .addCase(GetAppSettingsAction.fulfilled, (state, action) => {
        state.settingsLoading = false;
        state.settings = action.payload.response;
      })
      .addCase(GetAppSettingsAction.rejected, (state) => {
        state.settingsLoading = false;
        state.settings = null;
      });
  },
});

export default settingsSlice.reducer;
